import React, { useState } from 'react';

import { EditOutlined } from '@ant-design/icons';
import { Button, Form, Input, Modal } from 'antd';
import { toast } from 'react-toastify';
import { Partner } from 'src/interfaces/entities/partners';
import { useEditPartnerMutation } from 'src/redux/services/centralApi';

interface IEditPartnerForm {
	name: string;
}

export default function EditPartner(
	{
		row,
	}: { row: Partner }
) {
	const [ open, setOpen, ] = useState<boolean>(false);

	const [ editPartner, editPartnerResult, ] = useEditPartnerMutation();

	const [ editPartnerForm, ] = Form.useForm<IEditPartnerForm>();

	const onFinishEditPartnerForm = (data: IEditPartnerForm) => {
		editPartner({
			id: row.id,
			body: {
				name: data.name,
			},
		})
			.unwrap()
			.then(() => {
				toast.success('Parceiro atualizado com sucesso!', {
					autoClose: 1000,
				});
			})
			.catch((err) => {
				if (err?.status && err?.status === 500
					&& err?.data?.frontend_message) {
					toast.error(err?.data?.frontend_message, {
						autoClose: 1000,
					});
				}
			})
			.finally(() => {
				setOpen(false);
				editPartnerForm.resetFields();
			});
	};

	return <>
		<Button
			type="text"
			icon={<EditOutlined />}
			onClick={() => setOpen(true)}
		/>
		<Modal
			centered
			title={'Editar Parceiro'}
			open={open}
			onCancel={() => {
				setOpen(false);
				toast.info('Operação cancelada!', { autoClose: 1000, });
			}}
			destroyOnHidden
			confirmLoading={editPartnerResult.isLoading}
			okText="Salvar"
			onOk={() => {
				editPartnerForm.submit();
			}}
		>
			<Form
				layout="vertical"
				onFinish={onFinishEditPartnerForm}
				form={editPartnerForm}
				style={{ marginTop: 10, }}
			>
				<Form.Item
					initialValue={row.name}
					name={'name'}
					hasFeedback
					required
					tooltip={'Insira o nome do parceiro.'}
					label={'Nome do parceiro'}
					rules={[
						{
							required: true,
							message: 'Campo obrigatório.',
						},
					]}
				>
					<Input
						defaultValue={row.name}
						placeholder="Nome do parceiro"
					/>
				</Form.Item>
			</Form>
		</Modal>
	</>;
}